<template>
  <div class="partsSelectWrap" v-loading="partsLoading && choosePartsLoading">
    <div class="clearfix partsSelecTitle">
      <span class="fl">配件加购</span>
      <span class="fr totalNum">
        已选{{ warehouseItem.annexTotalNum || getTotalNum(data) }}件 共<span>
          <img
            :src="union_icon || require('@/assets/images/fudou.png')"
            alt="fudou"
            class="fudou-15"
          /><em class="text-num-c111">{{
            (
              parseFloat(Number(warehouseItem.annexTotalGoodsAmount * union_scale))
            ).toFixed(2)
          }}</em>
        </span>
      </span>
    </div>
    <div class="partsList">
      <div
        v-for="(item, index) in data"
        :key="index"
        v-show="showMore || index <= 7"
        class="partsItem"
      >
        <img
          :src="item.imgGuide || require('@/assets/images/allGone.png')"
          class="fl partsImg"
        />
        <div class="fr partsInfo">
          <div class="partsInfoTitle">{{ item.specValue1 }}{{ item.specValue2 }}</div>
          <div class="itemSelect">
            <span class="fl" style="margin-top: -2px;">
              <img
                :src="union_icon || require('@/assets/images/fudou.png')"
                alt="fudou"
                class="fudou-15"
              /><em
                style="margin-left: 2px;"
                v-html="getContent((
                  parseFloat(Number((item.price || 0) * union_scale))
                ).toFixed(2))"
              ></em>
            </span>
            <div class="fr operateNum">
              <div
                v-if="item.num > 0"
                class="clearfix"
              >
                <img
                  class="fr"
                  :class="item.num >= item.inventoryNum ? 'gray' : ''"
                  :src="require('@/assets/images/order/parts/partsAdd.png')"
                  @click="Addparts(item, warehouseItem)"
                />
                <div class="fr countNumShowWrap">
                  <span
                    class="countNumShow"
                    :style="{opacity: currentIndex == index ? 0 : 1}"
                    @click="chooseCurrent(item, index)"
                  >{{ currentIndex == index ? value : item.num }}</span>
                  <input
                    class="countNumShow countNumShowIpt"
                    v-if="currentIndex == index"
                    v-model="value"
                    :placeholder="item.num"
                    maxlength="8"
                    autofocus="autofocus"
                    @input="onCountChange('value')"
                  />
                </div>
                
                <img
                  class="fr"
                  :src="require('@/assets/images/order/parts/partsMinus.png')"
                  @click="Minusparts(item, warehouseItem)"
                />
              </div>
              <img
                v-else
                :src="require('@/assets/images/order/parts/partsAdd.png')"
                @click="Addparts(item, warehouseItem)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="showMorePart" v-if="data && data.length > 8" @click="showMore = !showMore">
      <span v-if="!showMore">
        <em>展开更多</em>
        <img
          :src="require('@/assets/images/order/parts/partsMore.png')"
          class="fudou-16"
        />
      </span>
      <span v-else>
        <em>收起</em>
        <img
          :src="require('@/assets/images/order/parts/partsArrow.png')"
          class="fudou-16"
        />
      </span>
    </div>
  </div>
</template>

<script>
import { deleteOrder } from '@fetch/order';
import Toast from "@components/simpleToast";
export default {
  name: 'PartsSelect',
  props: {
    warehouseItem: Object,
    data: Array,
    unpaidAmount: Number,
    loading: Boolean,
    historyLink: String,
    onModifyNum: Function,
    choosePartsLoading: Boolean,
  },
  data() {
    return {
      delModalVisible: false,
      partsLoading: false,
      showMore: false,
      orignValue: null,
      value: null,
      showInput: false,
      currentIndex: -1,
      chooseItem: null,
      inventoryNum: -1,
    };
  },
  methods: {
    confirmDelOrder() {
      deleteOrder({ orderNo: this.activeOrderNo }).then((res) => {
        // this.$parent.initData();
      });
      // this.activeOrderNo = "";
      this.delModalVisible = false;
    },
    chooseCurrent(item, index) {
      this.currentIndex = index;
      this.chooseItem = item;
      this.chooseWarehouseItem = this.warehouseItem;
      this.orignValue = JSON.parse(JSON.stringify(item.num));
      this.value = item.num;
      this.inventoryNum = item.inventoryNum;
    },
    showLoading(){
      this.partsLoading = true;
      setTimeout(() => {
        this.partsLoading = false;
      }, 2500);
    },
    checkChange(limit) {
      if (this.value != this.orignValue) {
        this.showLoading();
        this.onModifyNum(this.chooseItem, limit, 'input', this.chooseWarehouseItem);
        this.orignValue = this.value;
      }
    },
    onCountChange(val) {
      //只能输入数字
      this[val]= this[val].replace(/[^0-9]/g,'');
      let numVal = parseInt(this[val], 10);
      // console.log('numVal', numVal, this.orignValue);
      if (isNaN(numVal)) {
        this.value = 1;
        this.checkChange(this.value);
        return;
      }
      if (numVal > this.inventoryNum) {
        this.value = this.inventoryNum;
        Toast.info(this.ReplaceText('SSS', this.inventoryNum, this.TLang('商品仅剩', 'goods')), 1);
        this.checkChange(this.inventoryNum);
        return;
      }
      if (numVal <= 0) {
        this.value = 0;
        this.checkChange(this.value);
        return;
      }
      this.checkChange(numVal);
    },
    Addparts(item, warehouseItem) {
      this.currentIndex = -1;
      if (item.num >= item.inventoryNum) {
        Toast.info(this.ReplaceText('SSS', item.inventoryNum, this.TLang('商品仅剩', 'goods')), 1);
        return;
      }
      this.showLoading();
      this.onModifyNum(item, item.num+1, 'add', warehouseItem);
    },
    Minusparts(item, warehouseItem) {
      this.currentIndex = -1;
      if (item.num > 0) {
        this.showLoading();
        this.onModifyNum(item, item.num-1, 'minus', warehouseItem);
      }
    },
    getTotalNum(info) {
      let num = 0;
      if(info && info.length > 0) {
        info.forEach((i,a)=> {
          num = num + i.num;
        });
      };
      return num;
    },
    getContent(str) {
      let arr = str.split('.');
      return `${arr[0]}<em style="font-size: 11px; vertical-align: text-bottom;">.${arr[1]}</em>`;
    },
  },
};
</script>

<style lang="less">
.partsSelectWrap {
  width: 100%;
  background: #fff;
  padding: 23px 24px 9px !important;
  box-sizing: border-box;
  .partsSelecTitle {
    background: #fff;
    line-height: 21px;
    margin-bottom: 24px;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #111111;
    .totalNum {
      font-size: 13px;
      font-family: MicrosoftYaHei;
      color: #333333;
    }
  }
  .partsList {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .partsItem {
      width: 270px;
      height: 100px;
      background: #F7F7F7;
      border-radius: 4px;
      margin-bottom: 24px;
      box-sizing: border-box;
      padding: 5px;
      margin-right: 23px;
      &:nth-of-type(4n){
        margin-right: 0;
      }
      .partsImg {
        width: 90px;
        height: 90px;
        border: 1px solid #F0F0F0;
        box-sizing: border-box;
      }
      .partsInfo {
        width: 165px;
        height: 100%;
        position: relative;
        .partsInfoTitle {
          width: 100%;
          height: 36px;
          line-height: 18px;
          font-size: 13px;
          color: #333;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .itemSelect {
          position: absolute;
          width: 100%;
          right: 0;
          bottom: 0;
          font-size: 15px;
        }
        .operateNum {
          img {
            width: 18px;
            height: 18px;
            margin: 0;
            padding: 0;
            cursor: pointer;
          }
          .countNumShow {
            display: block;
            text-align: center;
            padding: 0;
            height: 18px;
            line-height: 18px;
            font-size: 12px;
            color: #333;
            font-family: MicrosoftYaHei, '微软雅黑';
            width: 32px;
          }
          .countNumShowWrap {
            position: relative;
            overflow: hidden;
          }
          .countNumShowIpt {
            position: absolute;
            text-align: center;
            left: 0;
            top: 0;
            display: inline-block;
            // width: auto;
            // max-width: 120px;
            width: 32px;
            border: none;
            background: transparent;
          }
        }
      }
    }
  }
  .showMorePart {
    width: 8%;
    margin: 0 auto;
    text-align: center;
    line-height: 16px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #666;
    cursor: pointer;
  }
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
.clearfix {
  *zoom: 1;
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.gray{
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
}
</style>
